import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adhoc-requests',
  templateUrl: './adhoc-requests.component.html',
  styleUrls: ['./adhoc-requests.component.css']
})
export class AdhocRequestsComponent implements OnInit {
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  minDate = new Date();
  constructor() {
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.bsValue, this.maxDate];
   }

  ngOnInit(): void {
  }
  employeeRecords = [
    {
      employeeId: '001',
      name: 'John Doe',
      adhocType: 'Adhoc Type A',
      rosterDate: '2024-02-28',
      loginTime: '09:00 AM',
      logoutTime: '05:00 PM',
      updationType: 'Change Request',
      reason:"test"
    },
    {
      employeeId: '002',
      name: 'Jane Smith',
      adhocType: 'Adhoc Type B',
      rosterDate: '2024-03-01',
      loginTime: '08:30 AM',
      logoutTime: '04:30 PM',
      updationType: 'Change Request',
      reason:"test"
    },
    {
      employeeId: '003',
      name: 'Michael Johnson',
      adhocType: 'Adhoc Type C',
      rosterDate: '2024-03-02',
      loginTime: '09:15 AM',
      logoutTime: '05:15 PM',
      updationType: 'Change Request',
      reason:"test"
    },
    {
      employeeId: '004',
      name: 'Sarah Brown',
      adhocType: 'Adhoc Type D',
      rosterDate: '2024-03-03',
      loginTime: '08:45 AM',
      logoutTime: '04:45 PM',
      updationType: 'Change Request',
      reason:"test"
    },
    {
      employeeId: '005',
      name: 'Robert Wilson',
      adhocType: 'Adhoc Type E',
      rosterDate: '2024-03-04',
      loginTime: '09:30 AM',
      logoutTime: '05:30 PM',
      updationType: 'Change Request',
      reason:"test"
    }
  ];
}
